import * as Yup from 'yup';
import Validations from "../../utils/Validations";

export const ChangePasswordEmailCpfValidationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("O E-mail informado não é valido.")
    .required("O campo E-mail é obrigatório."),
});
